import React from "react";
import AudioTag from "./AudioTag";
import ImageFullScreen from "../../../../components/App/shared/ImageFullScreen";
import { playMedium } from "../../../../api/media";
import VideoTag from "./VideoTag";

export default ({
  medium,
  mediumSetter,
  className,
  onClick,
  onPlayMedium,
  source,
  showFullScreenImag,
  showProgress = false,
  showActions = false,
  removeMedium,
  user,
  mobile,
}) => {
  const markPlay = () => {
    playMedium(medium.id);
  };
  if (!medium) return null;
  switch (medium.type) {
    case "Video":
      return mobile ? (
        <iframe
          className={`timeline-video ${className}`}
          src={medium.url}
          title={medium.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <VideoTag className={className} medium={medium} onClick={onClick} />
      );
    case "Image":
      return showFullScreenImag ? (
        <ImageFullScreen imgSrc={medium.url}>
          <img className={className} src={medium.url} alt={medium.title} onClick={onClick} />
        </ImageFullScreen>
      ) : (
        <img className={className} src={medium.url} alt={medium.title} onClick={onClick} />
      );
    case "SoundTrack":
      return (
        <AudioTag
          source={source}
          className={className}
          showActions={showActions}
          showProgress={showProgress}
          medium={medium}
          mediumSetter={mediumSetter}
          removeMedium={removeMedium}
          user={user}
        />
      );
    default:
      return <p className="text-danger">Invalid Media</p>;
  }
};
